import React from "react";

import { ProgressDot } from "./__internal__/ProgressDot";
import {
  IProgressBarProps,
  SegmentedProgressBar,
} from "./__internal__/SegmentedProgressBar";

export const VolumePricingProgressBar: React.FC<IProgressBarProps> = ({
  progress,
  isSmall,
}) => {
  return (
    <SegmentedProgressBar
      progress={progress}
      isSmall={isSmall}
      ProgressDot={ProgressDot}
    />
  );
};
